import React from "react";

export default function SectionCard({ title, desc, right, children }) {
    return (
        <div className="pv2-card">
            <div className="pv2-card-head">
                <div>
                    <div className="pv2-card-title">{title}</div>
                    {desc ? <div className="pv2-card-desc">{desc}</div> : null}
                </div>
                {right ? <div className="pv2-card-right">{right}</div> : null}
            </div>
            <div className="pv2-card-body">{children}</div>
        </div>
    );
}
